<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
.el-input {
  min-width: 120px;
}

/* 取消 Element UI 表格鼠标滑过行的背景色 */
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent !important;
}
</style>
